import { Nullable } from "@utils/types";

import { ContractWithSavingsRate } from "./getBasicSavingsRatePercent";

export const getAdditionalSavingsRatePercent = (contract: ContractWithSavingsRate): Nullable<number> =>
  contract?.savingsRate?.additional?.savingsRatePercent ?? null;

export const getAdditionalBottomSalary = (contract: ContractWithSavingsRate): Nullable<number> =>
  contract?.savingsRate?.additional?.bottomSalary ?? null;

export const getAdditionalTopSalary = (contract: ContractWithSavingsRate): Nullable<number> =>
  contract?.savingsRate?.additional?.topSalary ?? null;
